export default "__VITE_ASSET__Bn_VzfRn__"